// extracted by mini-css-extract-plugin
export default {"description":"BannerDescription_description__z9kdX","flower":"BannerDescription_flower__yCbAs"};